const fa = {
  common: {
    loading: 'در حال بارگذاری…',
    back: 'بازگشت',
    copy: 'کپی',
    copied: 'کپی شد',
    error: 'خطا',
    retry: 'تلاش دوباره',
    play: 'بازی کن',
    go: 'برو',
    save: 'ذخیره',
    send: 'ارسال',
    cancel: 'انصراف',
    confirm: 'تأیید',
    friend: 'دوست',
    noName: 'بدون نام',
    all: 'کل',
    daily: 'روزانه',
    monthly: 'ماهانه',
    rank: 'رتبه',
    league: 'لیگ',
    bigMatch: 'بازی بزرگ',
    user: 'کاربر',
    submitting: 'در حال ثبت…',
    sending: 'در حال ارسال…',
    watchingAd: 'در حال نمایش تبلیغ…',
    free: 'رایگان',
    search: 'جستجو',
    cardMasked: 'کارت: **** **** **** {last4}',
  },
  coins: {
    gold: 'طلایی',
    silver: 'نقره',
    bronze: 'برنزی',
    diamond: 'الماسی',
    coin: 'سکه',
  },
  nav: {
    aria: 'منوی اصلی',
    home: 'خانه',
    games: 'بازی‌ها',
    football: 'فوتبال',
    horse: 'اسب',
    airdrop: 'ایردراپ',
    gift: 'هدیه',
    profile: 'پروفایل',
  },
  home: {
    hello: 'سلام، {name}',
    luckyTitle: 'شانس اعداد',
    luckySub: '۴ مرحله · برنز تا الماس · ۲۰ دقیقه',
    quickStart: 'شروع سریع',
    allGames: 'همه بازی‌ها ‹',
    tiles: {
      airdrop: { title: 'ایردراپ روزانه', subtitle: 'جایزه هر روز' },
      guess: { title: 'حدس عدد', subtitle: '۷ رقم · بدون ۴' },
      football: { title: 'فوتبال', subtitle: 'لیگ و بازی بزرگ' },
      horse: { title: 'نظرسنجی اسب', subtitle: 'کورس و پیش‌بینی' },
      gift: { title: 'کارت هدیه', subtitle: 'کد هدیه بگیر' },
      wallet: { title: 'کیف پول', subtitle: 'موجودی سکه‌ها' },
      cash: { title: 'نقد کردن', subtitle: 'برداشت جایزه' },
      profile: { title: 'پروفایل', subtitle: 'سطح و دعوت‌ها' },
      support: { title: 'پشتیبانی', subtitle: 'چت مستقیم با تیم' },
    },
    social: {
      sectionAria: 'کانال‌های ما',
      title: 'کانال‌های ما',
      instagram: 'اینستاگرام',
      telegram: 'تلگرام',
      twitter: 'توییتر',
      youtube: 'یوتیوب',
      tiktok: 'تیک‌تاک',
    },
  },
  games: {
    title: 'بازی‌ها',
    subtitle: 'یکی را انتخاب کن و وارد شو',
    status: 'وضعیت',
    chances: 'شانس',
    of10: '{n} از ۱۰',
    todayNumber: 'عدد امروز',
    revealed: 'عدد افشا شده',
    active: 'بازی فعال',
    waiting: 'در انتظار عدد',
    cards: {
      guess: {
        title: 'حدس عدد',
        subtitle: 'عدد ۷ رقمی بدون عدد ۴',
      },
      lucky: {
        title: 'شانس اعداد',
        subtitle: '۴ مرحله · برنز تا الماس · ۲۰ دقیقه',
        blurb: 'از بین اعداد انتخاب کن. شانس تموم شد؟ تبلیغ ببین.',
      },
      morse: {
        title: 'کد مورس',
        subtitle: 'دکمه مورس · سکه طلا',
        blurb: 'با دکمه مورس کلمه را بساز. هر درست: طلا، برای معرف: نقره.',
      },
      horse: {
        title: 'نظرسنجی اسب',
        subtitle: 'هورس لیگ · سه در چهار · دو قلو',
        blurb: 'پیش‌بینی نتیجه کورس‌ها با سکه برنز و جایزه طلا/الماس.',
      },
    },
  },
  wallet: {
    title: 'کیف پول',
    subtitle: 'موجودی سکه‌ها و نقد کردن',
    approxValue: 'ارزش یورویی',
    cashTitle: 'نقد کردن سکه‌ها',
    cashHint: 'برای نقد کردن نزد مدیر یا انتقال به کاربر دیگر، به صفحه نقد کردن بروید.',
    goCashOut: 'رفتن به نقد کردن',
    convertTitle: 'تبدیل سکه',
    convertHint: 'قیمت هر سکه را ادمین به یورو تعیین می‌کند. فقط تعداد کامل سکهٔ مقصد داده می‌شود و بقیه روی سکهٔ مبدأ می‌ماند.',
    convertFrom: 'از',
    convertTo: 'به',
    convertAmount: 'مقدار',
    convertBalance: 'موجودی: {n}',
    convertValue: 'ارزش {amount} {coin}: {eur}',
    convertResult: '{receive} {to} می‌گیری · {leftover} {from} می‌ماند',
    convertTooSmall: 'حداقل {min} {from} برای یک {to}',
    convertSame: 'مبدأ و مقصد باید متفاوت باشند',
    convertSubmit: 'تبدیل',
    convertOk: '{spent} {from} شد {receive} {to}',
    convertNeedFunds: 'موجودی کافی نیست',
    eachRate: 'هر سکه {eur}',
  },
  cashOut: {
    title: 'نقد کردن',
    subtitle: 'انتقال سکه یا برداشت نزد مدیر',
    unlock: 'باز کردن با رمز',
    setPin: 'تنظیم رمز',
    enterPin: 'ورود رمز',
    pinHint: 'رمز ۴ تا ۸ رقمی',
    toAdmin: 'نزد مدیر',
    toUser: 'به کاربر',
    amount: 'مقدار',
    coinType: 'نوع سکه',
    walletAddress: 'آدرس کیف پول',
    recipient: 'شناسه گیرنده',
    submit: 'ثبت درخواست',
    transfer: 'انتقال',
    history: 'تاریخچه',
    statusCompleted: 'تکمیل شده',
    statusPending: 'در انتظار',
    statusApproved: 'تایید مدیر',
    statusRejected: 'رد شده',
    pinSetOk: 'رمز با موفقیت تنظیم شد',
    pinUnlockOk: 'وارد بخش نقد کردن شدید',
    pinWrong: 'رمز نادرست',
    pinSetErr: 'خطا در تنظیم رمز',
    transferOk: 'انتقال با موفقیت انجام شد',
    transferErr: 'خطا در انتقال',
    adminOk: 'درخواست نقد کردن نزد مدیر ثبت شد',
    adminErr: 'خطا در ثبت درخواست',
    errPinLength: 'رمز باید ۴ تا ۶ رقمی باشد',
    errUnlockFirst: 'ابتدا با رمز وارد بخش نقد کردن شوید',
    errAmount: 'مقدار سکه را وارد کنید',
    errInsufficient: 'موجودی کافی نیست',
    errRecipient: 'شناسه یا یوزرنیم گیرنده را وارد کنید',
    errWallet: 'آدرس کیف پول را وارد کنید',
    intro: 'سکه‌هایی که از بازی و جوایز گرفته‌اید را اینجا نقد کنید یا به کاربر دیگر بفرستید.',
    sectionTitle: 'ورود به نقد کردن',
    pinSetupHint: 'ابتدا یک رمز برای این بخش تنظیم کنید',
    unlockedHint: 'بخش نقد کردن باز است',
    pinEnterHint: 'برای ورود، رمز خود را وارد کنید',
    unlockPinBtn: 'ورود با رمز',
    lock: 'قفل کردن',
    lockedBanner: 'بخش نقد کردن قفل است. ابتدا رمز را تنظیم یا وارد کنید.',
    tabAdmin: 'انتقال به مدیر',
    tabUser: 'انتقال به کاربر',
    walletPlaceholder: 'آدرس کیف پول مقصد',
    recipientLabel: 'شناسه یا یوزرنیم گیرنده',
    recipientPlaceholder: 'مثال: 84729103 یا @username',
    amountLabel: 'مقدار سکه',
    amountPlaceholder: 'مقدار',
    submitAdmin: 'ثبت نقد کردن نزد مدیر',
    submitUser: 'انتقال به کاربر',
    historyTitle: 'تاریخچه نقد کردن',
    historyEmpty: 'هنوز درخواستی ثبت نشده است',
    historyToUser: 'به کاربر {id}',
    historyToAdmin: 'به مدیر',
    modalSetTitle: 'تنظیم رمز بخش نقد کردن',
    modalUnlockTitle: 'ورود به بخش نقد کردن',
    modalSetBody: 'یک رمز ۴ تا ۶ رقمی انتخاب کنید تا فقط شما به این بخش دسترسی داشته باشید.',
    modalUnlockBody: 'رمز بخش نقد کردن را وارد کنید',
    pinPlaceholder: 'رمز ۴-۶ رقمی',
    modalSetSubmit: 'تنظیم و ورود',
    modalUnlockSubmit: 'ورود',
  },
  profile: {
    language: 'زبان',
    languageHint: 'زبان رابط کاربری را انتخاب کنید',
    invites: 'دعوت‌ها',
    level: 'سطح',
    bestCoin: 'بهترین سکه',
    idLabel: 'شناسه',
    idCopyTitle: 'کپی شناسه برای انتقال سکه',
    achievements: 'دستاوردها',
    badgeFirst: 'اولین سکه',
    badgeInvite: '۵ دعوت موفق',
    badgeLucky: 'مرحله ۳ شانس',
    luckyProgress: 'میزان پیشرفت · شانس اعداد',
    footballScore: 'امتیاز فوتبال',
    footballScoreHint: 'امتیاز تجمعی است و پاک نمی‌شود.',
    noLeagueYet: 'هنوز در لیگ یا بازی بزرگ شرکت نکرده‌اید',
    footballPrizes: 'جوایز فوتبال',
    inviteFriends: 'دعوت دوستان',
    inviteHint: 'با اشتراک‌گذاری کد یا اسکن QR، برای هر ثبت‌نام یک سکه برنزی می‌گیری.',
    qrLabel: 'کیوآر کد لینک دعوت',
    qrHint: 'اسکن برای باز شدن لینک دعوت',
    copyInviteLink: 'کپی لینک دعوت',
    linkCopied: 'لینک کپی شد',
    topUsers: 'تاپ یوزر',
    topUsersHint: 'برترین کاربران در لیگ فوتبال، لیگ اسب‌سواری، ایردراپ و دعوت',
    viewTopUsers: 'مشاهده تاپ یوزر',
  },
  register: {
    subtitle: 'برای شروع، کد دعوت را وارد کنید',
    pendingTeam: 'بعد از ثبت‌نام به تیم رویایی دعوت‌شده می‌روید',
    noCodeTitle: 'کد ریفرال ندارید؟',
    noCodeHint: 'اگر کد ریفرال ندارید، در کادر پایین همین @sisil_org را وارد کنید.',
    referralLabel: 'کد ریفرال',
    referralPlaceholder: '@sisil_org',
    getRandomCode: 'دریافت کد ریفرال تصادفی',
    submit: 'ثبت‌نام و ورود',
    submitting: 'در حال ثبت‌نام…',
    foot: 'کد دعوت دوستان را بزنید؛ اگر ندارید @sisil_org را وارد کنید.',
    needTelegram: 'لطفاً از طریق ربات تلگرام وارد شوید',
    noTgData: 'اطلاعات تلگرام یافت نشد. لطفاً از طریق ربات وارد شوید.',
    registerFail: 'ثبت‌نام با خطا مواجه شد. دوباره تلاش کنید.',
    registerErr: 'خطا در ثبت‌نام.',
    codeFetchErr: 'خطا در دریافت کد ریفرال',
  },
  support: {
    title: 'پشتیبانی',
    meta: 'چت مستقیم · پیام‌ها بعد از ۷ روز پاک می‌شوند',
    empty: 'سلام! سوالت رو همین‌جا بنویس.',
    placeholder: 'پیام خود را بنویسید...',
    sendErr: 'خطا در ارسال',
  },
  airdrop: {
    title: 'ایردراپ',
    subtitle: 'حضور روزانه و جایزه',
    wallet: 'کیف پول',
    leadersToday: 'برترین‌های امروز',
    leadersMonth: 'برترین‌های ماه',
    usefulTime: 'زمان مفید',
    play: 'بازی',
    cooldown: 'استراحت',
    watchAd: 'تماشای تبلیغ',
    claim: 'دریافت جایزه',
    toastUsefulCharged: '۵ دقیقه مفید شارژ شد',
    scoreToday: 'امتیاز امروز',
    waitNextTurn: 'صبر تا نوبت بعدی',
    usefulTimerActive: '۵ دقیقه مفید (فقط وقتی در صفحه هستید)',
    closedHours: 'از ساعت ۲۳:۰۰ تا ۰۰:۰۰ بسته است',
    berlinTime: 'وقت آلمان',
    tapAriaActive: 'کلیک برای امتیاز',
    tapAriaLocked: 'ایردراپ غیرفعال',
    glassClosed: 'بسته است',
    glassCooldown: 'نوبت تمام شد',
    glassClosedDetail: '۲۳:۰۰ تا ۰۰:۰۰ · وقت آلمان',
    glassCooldownDetail: '{time} صبر کنید یا تبلیغ ببینید',
    watchAdInstant: 'تبلیغ ببین · شارژ فوری ۵ دقیقه',
    hintRegistering: 'در حال ثبت…',
    hintConnecting: 'در حال اتصال…',
    hintTimerRunning: 'تایمر در حال شمارش · هر بار بزنی +۱',
    hintTimerPaused: 'تایمر متوقف · به صفحه برگردید',
    hintNightlyClosed: 'هر شب این یک ساعت برای همه بسته است',
    hintCooldownOrAd: '۵ دقیقه صبر کنید، یا با تبلیغ فوراً شارژ شوید',
    leadersTablistAria: 'برترین‌ها',
    emptyNoScores: 'هنوز امتیازی ثبت نشده',
    emptyNoData: 'هیچ داده‌ای یافت نشد',
  },
  football: {
    title: 'فوتبال',
    subtitle: 'لیگ روزانه یا بازی بزرگ را انتخاب کن',
    modeLeague: 'لیگ روزانه',
    modeBig: 'بازی بزرگ',
    dailyLeague: 'لیگ روزانه',
    hintLeague:
      'بازی‌های روزانه: برای همه بازی‌ها برد / مساوی / باخت را مشخص کنید (یک، دو یا هر سه) و یکجا ثبت کنید — ۱ درست=۸، دو انتخاب و یکی درست=۴، هر سه=۲. هر روز نفر اول سکه طلا و رفررش سکه نقره می‌گیرد و آخر ماه ۵ نفر اول سکه طلا.',
    hintBig:
      'بازی‌های هفتگی: برد / مساوی / باخت را مشخص کنید و تیم رویایی بسازید؛ موقع ثبت نتیجه بین تعداد مشخص‌شده از پیش‌بینی‌های درست قرعه‌کشی طلا می‌شود و بهترین تیم رویایی سکه می‌گیرد.',
    tabMatches: 'مسابقات',
    tabLeaderboard: 'لیدربورد',
    tabDreamTeams: 'تیم‌های رویایی',
    tabWinnings: 'جوایز من',
    totalScore: 'امتیاز کل',
    dayScore: 'روز',
    monthScore: 'ماه',
    noScore: 'هنوز امتیازی ثبت نشده',
    noWinnings: 'هنوز جایزه‌ای برنده نشده‌اید',
    goldCoin: 'سکه طلا',
    silverCoin: 'سکه نقره',
    submitPredictions: 'ثبت همه نظرسنجی‌ها',
    submitting: 'در حال ثبت…',
    pickRequired: 'برای هر مسابقه حداقل یک انتخاب لازم است',
    loadingMatches: 'در حال بارگذاری مسابقات…',
    noBigMatch: 'بازی بزرگی در حال حاضر تعریف نشده است',
    noLeagueMatch: 'بازی لیگی در حال حاضر تعریف نشده است',
    noActiveLeague: 'لیگ فعالی وجود ندارد',
    readyBatch: 'آماده ثبت {n} بازی',
    draftHint: 'برای {n} بازی باز در نظرسنجی شرکت کنید، بعد یکجا ثبت کنید',
    topOf: 'برترین‌های {mode}',
    wonPrizes: 'جوایز برنده شده',
    dayMonth: 'روز {day} · ماه {month}',
    outcomeHome: 'برد',
    outcomeAway: 'باخت',
    outcomeDraw: 'مساوی',
    dayGoalsTitle: 'حدس مجموع گل‌های روز',
    dayGoalsHint:
      'مجموع گل میزبان و میهمان در {n} بازی این روز را حدس بزن. اگر هر دو درست باشد ۱ سکه نقره می‌گیری (بدون پاداش معرف). هزینه: ۱ برنز یا یک ویدیو.',
    dayGoalsHome: 'مجموع گل میزبان‌ها',
    dayGoalsAway: 'مجموع گل میهمان‌ها',
    dayGoalsPayBronze: 'ثبت با {n} برنز',
    dayGoalsPayAd: 'تماشای ویدیو',
    dayGoalsSubmitAfterAd: 'ثبت حدس',
    dayGoalsAdReadyHint: 'ویدیو دیده شد — حالا حدس را ثبت کن',
    dayGoalsSubmitted: 'حدس ثبت شد: میزبان {home} · میهمان {away}',
    dayGoalsInvalid: 'تعداد گل باید عدد صحیح صفر یا بیشتر باشد',
    dayGoalsErr: 'خطا در ثبت حدس گل',
    draws: {
      daily_correct: 'قرعه روزانه لیگ',
      weekly_correct: 'قرعه هفتگی بازی بزرگ',
      daily_top: 'برنده امتیاز روز',
      daily_referral: 'پاداش رفرال برنده روز',
      monthly_top: 'نفرات برتر ماه',
      best_dream_team: 'بهترین تیم رویایی',
      weekly_dream_team_raffle: 'قرعه تیم‌های رویایی',
      league_day_goals: 'حدس مجموع گل روز لیگ',
    },
    errSubmitPrediction: 'خطا در ثبت پیش‌بینی',
    errSubmitPoll: 'خطا در ثبت نظرسنجی',
    statusLive: 'زنده',
    statusFinished: 'تمام شده',
    statusUpcoming: 'پیش‌رو',
    yourPoll: 'نظرسنجی شما',
    yourPrediction: 'پیش‌بینی شما',
    pickedSuffix: '(نسبت به {team})',
    pickHint: 'نتیجه از دید {team} — برد / مساوی / باخت:',
    pollClosed: 'نظرسنجی برای این مسابقه بسته شده است',
    predictionClosed: 'پیش‌بینی برای این مسابقه بسته شده است',
    buildDreamTeam: 'ساخت تیم رویایی',
  },
  horse: {
    title: 'نظرسنجی اسب',
    subtitle: 'پیش‌بینی کورس و جایزه',
    modesTitle: 'حالت‌ها',
    leaderboard: 'رتبه‌بندی',
    myBets: 'پیش‌بینی‌های من',
    mode: {
      league: {
        label: 'هورس لیگ',
        fee: 'رایگان',
        hint: '۵–۱۵ کورس پشت‌هم · ۱ اسب · امتیاز ۹…۱ · برنده طلا · تاپ ماهانه',
      },
      three_in_four: {
        label: 'سه در چهار',
        fee: '۲ برنز یا ۵ ویدیو',
        hint: '۴ کورس · از هر کورس ۴ اسب فعال · در هر کورس ترتیب ۱…۴ را بزن · جمع امتیاز · طلا',
      },
      twins: {
        label: 'دو قلو',
        fee: '۲ برنز یا ۵ ویدیو',
        hint: '۵ کورس · ۲ اسب · ۳ درست طلا / ۵ درست الماس',
      },
      three_one: {
        label: 'سه تا یکی',
        fee: '۲ برنز یا ۵ ویدیو',
        hint: '۵ کورس · ۳ اسب · ۵ اول → طلا',
      },
      more_chance: {
        label: 'شانس بیشتر',
        fee: '۱ برنز یا ۳ ویدیو',
        hint: '۵ کورس · ۲ اسب · بهترین مقام · ≥۴۳ طلا',
      },
    },
    errLoad: 'خطا در بارگذاری',
    errGeneric: 'خطا',
    errWatchAdsFirst: 'اول {n} ویدیو ببین',
    msgSubmitted: 'نظرسنجی ثبت شد',
    errNotSubmitted: 'ثبت نشد',
    msgAdProgress: 'ویدیو ثبت شد · {watched} از {required}',
    errAdFailed: 'تبلیغ ثبت نشد',
    finishPosition: 'مقام {n}',
    entryPrefix: ' · ورودی: ',
    monthlyTop: 'تاپ یوزر ماهانه',
    yourScore: 'امتیاز شما:',
    todayScore: '(امروز {n})',
    emptyNoScores: 'هنوز امتیازی نیست',
    openPollsTitle: 'نظرسنجی‌های باز',
    emptyNoPolls: 'نظرسنجی بازی نیست',
    roundEntryPaid: 'ورودی {bronze} برنز یا {ads} ویدیو',
    courseCount: ' · {n} کورس',
    join: 'شرکت',
    entrySubmitted: 'ثبت شده · امتیاز: {score}',
    entryWinner: ' · برنده {amount} {type}',
    orderHint: 'ترتیب را مشخص کنید (۱ = جلوتر)',
    placeAmongHint: 'ترتیب این ۴ اسب فعال را مشخص کن: اول، دوم، سوم، چهارم',
    placeOption: 'مقام {n}',
    pickNHorses: ' · انتخاب {n} اسب',
    submitPoll: 'ثبت نظرسنجی',
    submitWithBronze: 'ثبت با {n} برنز',
    watchVideos: 'ویدیو ببین ({watched} از {required})',
    submitWithVideos: 'ثبت با ویدیو ({n})',
    roundLeaderboard: 'رتبه‌بندی این دور',
    votingClosed: 'ثبت نظر بسته است — کورس شروع شده یا ادمین بسته است',
    historyTitle: 'تاریخچه نظرهای من',
    historyEmpty: 'هنوز در نظرسنجی شرکت نکرده‌ای',
    historyView: 'مشاهده',
    historyYourPicks: 'نظر تو',
    historyOfficial: 'نتیجه رسمی',
    historyPending: 'نتیجه هنوز ثبت نشده',
    historyStatusOpen: 'در جریان',
    historyStatusWaiting: 'در انتظار نتیجه',
    historyStatusSettled: 'نتیجه ثبت شد',
    historyScore: 'امتیاز {score}',
    historyCorrect: '{n} درست',
    historyMine: 'انتخاب تو',
    historyPredicted: 'پیش‌بینی: مقام {n}',
    historyNoRound: 'اطلاعات این دور در دسترس نیست',
    historyOpenPoll: 'باز کردن همین نظرسنجی',
  },
  gift: {
    title: 'کارت هدیه',
    subtitle: 'کد هدیه بگیر و استفاده کن',
    redeem: 'استفاده از کد',
    myCodes: 'کدهای من',
    statusUsedWithPrize: 'استفاده شده · جایزه: {prize}',
    statusUsed: 'استفاده شده',
    statusExpired: 'منقضی شده',
    statusActiveHint: 'فعال — برای پر کردن روی آن بزنید',
    badgeUsed: 'استفاده شده',
    badgeExpired: 'منقضی',
    badgeActive: 'فعال',
    errEnterCode: 'کد را وارد کنید',
    errInvalidCode: 'کد معتبر نیست',
    noticeAlreadyUsed: 'این کد قبلاً استفاده شده است.',
    noticeExpired: 'این کد منقضی شده است و دیگر معتبر نیست.',
    noticeNotFound: 'این کد پیدا نشد.',
    errPickPrize: 'یک جایزه انتخاب کنید',
    claimOk: 'جایزه ثبت شد',
    errClaim: 'خطا در ثبت جایزه',
    intro:
      'اگر در ایردراپ برنده شده‌اید، کد یک‌ساعته را اینجا بزنید تا جوایز را ببینید و یکی را انتخاب کنید.',
    codeLabel: 'کد پاداش',
    codePlaceholder: 'مثلاً AIRDWARD-...',
    enterPrizes: 'ورود به جوایز',
    activeCodesTitle: 'کدهای فعال ({n})',
    inactiveCodesTitle: 'کدهای استفاده‌شده / منقضی ({n})',
    activeCodeLabel: 'کد فعال',
    pickTitle: 'یک جایزه انتخاب کنید',
    claimPrize: 'ثبت جایزه',
    doneTitle: 'جایزه ثبت شد',
    doneNote: 'این کد استفاده شده و دیگر قابل استفاده نیست.',
    exit: 'خروج از هدیه‌ها',
  },
  guess: {
    title: 'حدس عدد',
    subtitle: 'عدد ۷ رقمی بدون ۴',
    errSevenDigits: 'عدد باید عددی ۷ رقمی باشد',
    errNoFour:
      'عدد ۴ مجاز نیست - لطفا عددی بدون رقم ۴ وارد کنید (ارقام مجاز: ۰،۱،۲،۳،۵،۶،۷،۸،۹)',
    errSubmit: 'خطا در ثبت حدس',
    statusUnavailable: 'وضعیت بازی دریافت نشد',
    revealAt: 'افشا در ساعت ۲۳:۳۰',
    todayPrompt: 'امروز چه عددی؟',
    hint: 'عدد ۷ رقمی بدون رقم ۴ را حدس بزن. هر عدد را فقط یک‌بار می‌توانی ثبت کنی.',
    placeholder: 'مثلاً 1235678',
    attemptsLeft: 'شانس باقی‌مانده',
    submit: 'ثبت حدس',
    revealedTitle: 'عدد امروز افشا شد',
    bannerWin: 'تبریک! امروز برنده شدی',
    bannerLose: 'متاسفانه امروز برنده نشدی',
    winnersCount: 'امروز {n} نفر برنده شدند',
    noWinners: 'هیچ برنده‌ای امروز نداشتیم',
    waitingNoNumber: 'هنوز عدد امروز تعیین نشده',
    waitingSchedule: 'تولید در ۰۰:۰۱ · افشا در ۲۳:۳۰',
    untilReveal: 'تا افشا: {countdown}',
    winnersToday: 'برندگان امروز',
    userHash: 'کاربر #{id}',
    correctTag: 'درست',
  },
  lucky: {
    title: 'شانس اعداد',
    subtitle: '۴ مرحله تا الماس',
    unlimited: 'نامحدود',
    toastDemotedStageChance: 'وقت/شانس این مرحله تموم شد — برگشتی به مرحله اول',
    toastPickExact: 'باید دقیقاً {n} عدد انتخاب کنی',
    toastDemotedStage: 'وقت این مرحله تموم شد — برگشتی به مرحله اول',
    toastAdCharged: '✅ شانس شارژ شد',
    chancesLabel: 'شانس',
    stepsAria: 'مراحل',
    windowClosed: 'پنجره بازی امروز بسته است. فردا دوباره بیا.',
    allDoneTitle: 'همه مراحل امروز تمام شد!',
    allDoneHint: 'فردا دوباره شانس جدید داری.',
    sessionExpiredStage1:
      'وقت این جلسه تموم شد. ۳ شانس رایگان امروز همان می‌ماند و فردا پر می‌شود. ویدیو هنوز نامحدود است.',
    sessionExpiredRestart: 'وقت این مرحله تموم شد. با شروع مجدد به مرحله اول برمی‌گردی.',
    restart: 'شروع مجدد',
    hintPick: 'از بین {pool} عدد، {pick} تا را انتخاب کنید',
    hintOneWinner:
      'فقط ۱ عدد درست بین {pool} عدد هست — اگر همان را بین انتخاب‌هایت داشته باشی برنده می‌شوی',
    rewardLine: 'جایزه: سکه {coin} · انتخاب‌شده {selected}/{pick}',
    stage1Quota: '۳ شانس رایگان برای کل امروز است و فردا پر می‌شود · هر ویدیو ۵ شانس',
    stageFreePrefix: 'رایگان این مرحله: {free}',
    noAds: ' · بدون تبلیغ',
    adsRemaining: ' · تبلیغ باقی‌مانده: {n}',
    stageTimeLimit: ' · ۲۰ دقیقه فرصت',
    confirmPicks: 'تایید انتخاب‌ها',
    needAdNoFree: 'این مرحله شانس رایگان ندارد. یک تبلیغ ببین تا حدس بزنی.',
    needAdRecharge: 'شانس تموم شد. با دیدن تبلیغ شارژ کن.',
    watchAdPlus: 'تبلیغ ببین · +{n} شانس',
    loseDemotedTitle: 'برگشتی به مرحله اول',
    loseTitle: 'باختی!',
    correctWas: 'عدد درست این بود',
    loseDemotedHint: 'برگشتی به مرحله اول. شانس رایگان امروز همان است که مانده.',
    loseNumbersChanged: 'برای تلاش بعدی، اعداد شانس عوض شدند.',
    attemptsLeft: 'شانس باقی‌مانده: {n}',
    continueStage1: 'ادامه در مرحله اول',
    tryAgain: 'دوباره تلاش کن',
  },
  morse: {
    title: 'کد مورس',
    subtitle: 'کلمه را با مورس بساز',
    errEnterWord: 'با دکمه مورس کلمه را وارد کنید',
    windowClosedTitle: 'پنجره بازی امروز بسته است',
    windowClosedHint: 'فردا از نیمه‌شب تا ۲۳:۳۰ به وقت آلمان دوباره باز می‌شود',
    solved: 'حل‌شده',
    timeLeft: 'زمان باقی',
    clock: 'ساعت',
    keyTitle: 'کلید مورس',
    keyHint: 'کوتاه = نقطه · نگه داشتن = خط. بعد از مکث، حرف ثبت می‌شود.',
    readoutWord: 'Word',
    keyLabel: 'Morse',
    keyHoldHint: 'hold · · —',
    backspace: '⌫ حذف',
    submitGuess: 'ثبت حدس',
    clearAll: 'پاک کردن همه',
    sessionEnded: 'جلسه این نوبت تمام شد',
  },
  topUsers: {
    title: 'تاپ یوزر',
    subtitle: 'برترین‌ها در بخش‌های مختلف',
    emptyFootball: 'هنوز امتیازی در لیگ فوتبال ثبت نشده',
    emptyHorse: 'هنوز امتیازی در لیگ اسب‌سواری نیست',
    emptyAirdrop: 'هنوز امتیازی در ایردراپ ثبت نشده',
    emptyInvite: 'هنوز دعوتی ثبت نشده است',
    scoreLabel: 'امتیاز',
    inviteLabel: 'دعوت',
  },
  dreamTeam: {
    title: 'تیم رویایی',
    titlePlural: 'تیم‌های رویایی',
    brandBoard: 'تیم رویایی · Sisil',
    defaultTeamName: 'تیم رویایی من',
    matchVs: '{home} در برابر {away}',
    listSeparator: '، ',
    positions: {
      gk: 'دروازه‌بان',
      def: 'مدافع',
      mid: 'هافبک',
      fwd: 'مهاجم',
      voteShort: {
        def: 'دفاع',
        fwd: 'حمله',
      },
    },
    status: {
      draft: 'پیش‌نویس',
      submitted: 'ارسال‌شده',
      submittedSpaced: 'ارسال شده',
      notSubmitted: 'ارسال‌نشده',
      teamSubmittedCheck: 'تیم ارسال شده ✓',
      teamSubmittedHeading: '✅ تیم رویایی ارسال شد',
    },
    explore: {
      ariaSearch: 'جستجو',
      searchPlaceholder: 'جستجو…',
      empty: 'خالی',
      notFound: 'پیدا نشد',
      exploreTeams: '🔍 کاوش تیم‌ها',
    },
    view: {
      notFound: 'این تیم رویایی پیدا نشد',
      backToExplore: 'بازگشت به کاوش',
      labelTeamName: 'نام تیم رویایی',
      labelFormation: 'ترکیب تیم',
      metaRating: '★ {avg} ({votes}) · {totalScore} امتیاز',
      creator: 'سازنده: {name}',
      buildMyTeam: 'ساخت تیم خودم',
      pitchAlt: 'انیمیشن زمین تیم رویایی',
    },
    builderPage: {
      matchNotFound: 'مسابقه یافت نشد',
      backToFootball: 'بازگشت به فوتبال',
    },
    builder: {
      toastEnterName: 'نام تیم رویایی را وارد کنید',
      toastPlayersRemaining: 'هنوز {remaining} بازیکن جا مانده ({selected} از {total})',
      toastSaveError: 'خطا در ذخیره تیم رویایی',
      toastUpdated: 'تیم رویایی بروزرسانی شد',
      toastCreated: 'تیم رویایی ساخته شد',
      toastSubmitted: 'تیم رویایی ارسال شد',
      toastSubmitError: 'خطا در ارسال تیم رویایی',
      toastAnimationFailed: 'ساخت تصویر انیمیشنی ممکن نشد',
      toastLinkCopied: 'لینک تیم کپی شد',
      toastFileNotReady: 'فایل هنوز آماده نیست',
      toastWaitForFile: 'صبر کن تا فایل آماده شود…',
      toastVideoSaved: 'ویدیو ذخیره شد — در استوری همان ویدیو را بگذار تا انیمیشن پخش شود',
      toastGifSaved: 'گیف ذخیره شد — اگر استوری ثابت ماند، از ویدیو استفاده کن',
      toastStoryStepsVideo:
        'ویدیو در گالری است → استوری جدید → همان ویدیو را انتخاب کن → لینک را بچسبان',
      toastStoryStepsFile:
        'فایل در گالری است → استوری جدید → همان فایل را انتخاب کن → لینک را بچسبان',
      labelTeamName: 'نام تیم رویایی',
      labelFormation: 'ترکیب تیم',
      placeholderTeamName: 'مثال: تیم رویایی من',
      activeCardGroups: 'گروه کارت‌های فعال این بازی:',
      noActiveCards:
        'برای این بازی کارتی فعال نشده است. ادمین باید در تب «فوتبال» گروه کارت‌های این مسابقه را انتخاب کند.',
      pickEmpty: 'انتخاب',
      playersSelected: 'بازیکنان انتخاب‌شده: {selected} از {total}',
      filterAll: 'همه ({count})',
      pickPositionTitle: '{icon} انتخاب {position}',
      pickSlotHint: 'یک خانه روی زمین را انتخاب کنید',
      cardCount: '{count} کارت',
      tapEmptySlot: 'روی یکی از خانه‌های خالی زمین بزنید',
      noCardsForPosition: 'کارتی برای این موقعیت در گروه‌های فعال این بازی نیست',
      searchPlayerPlaceholder: 'جستجوی نام بازیکن...',
      badgeSelected: 'انتخاب‌شده',
      badgeInTeam: 'در تیم',
      badgeAdd: '+ اضافه',
      submittedBlurb:
        'پس از ارسال، ترکیب قفل می‌شود و در قرعه‌کشی و رقابت «بهترین تیم رویایی» شرکت می‌کند.',
      copyLink: 'کپی لینک',
      shareTeam: '📤 اشتراک‌گذاری تیم',
      submitTeam: 'ارسال تیم',
      saving: 'در حال ذخیره...',
      updateTeam: 'بروزرسانی تیم',
      buildTeam: 'ساخت تیم ({selected}/{total})',
      shareModal: {
        title: 'استوری با انیمیشن زمین',
        buildingComposition: 'در حال ساخت انیمیشن ترکیب…',
        fileNotReady: 'فایل هنوز آماده نیست',
        instagramTip:
          'اینستاگرام گیف گالری را معمولاً ثابت می‌کند — برای حرکت کارت‌ها ویدیوی کوتاه بگذار.',
        instagramSteps:
          '۱) ذخیره/اشتراک همین فایل ۲) استوری → همان ویدیو/گیف ۳) لینک را با استیکر بچسبان.',
        building: 'در حال ساخت انیمیشن…',
        shareVideo: '📤 ذخیره / اشتراک ویدیو زمین',
        shareGif: '📤 ذخیره / اشتراک گیف زمین',
        downloadVideo: 'دانلود ویدیو',
        downloadGif: 'دانلود گیف',
        copyBotLink: 'کپی لینک ربات',
      },
    },
    image: {
      stickerHint: 'لینک را با استیکر لینک به استوری بچسبان',
      cta: 'تیم رویایی خودت را بساز و امتیاز بگیر',
      unknownInitial: '؟',
    },
    voting: {
      sectionTitle: 'امتیازدهی (۱ تا ۵)',
      alreadyVoted: 'شما قبلاً نظر داده‌اید',
      yourRating: 'امتیاز شما: {rating}/5',
      pollClosed: 'نظرسنجی این بازی بسته شده است',
      pollClosedHint: 'رأی‌دهی فقط تا پیش از شروع بازی امکان‌پذیر است',
      ownerHint: 'این تیم خودتان است؛ دیگران می‌توانند به آن رأی بدهند.',
      slotLine: '{position} · اسلات {slot}',
      toastPollClosed: 'نظرسنجی این بازی بسته شده است',
      toastVoteRecorded: 'نظر شما ثبت شد',
      toastVoteError: 'خطا در ثبت نظر',
      toastCannotVoteOwn: 'نمی‌توانید به تیم خودتان رأی بدهید',
      votingOpen: 'رأی‌دهی باز',
      votingClosed: 'بسته',
      yourTeamChip: 'تیم شما',
      topTeamsTitle: 'بهترین تیم‌های این مسابقه',
    },
  },
  fantasy: {
    explore: {
      subtitleRefreshing: 'در حال به‌روزرسانی…',
      subtitleDefault: 'جستجو و رأی‌دهی',
      searchPlaceholder: 'جستجوی نام تیم یا لینک',
      resultsFor: 'نتیجه برای «{query}»',
      loadError: 'خطا در بارگذاری تیم‌ها',
      emptySearch: 'تیمی با این نام یا لینک پیدا نشد',
      emptyDefault: 'هنوز تیم فعالی برای رأی‌دهی وجود ندارد',
      backToMatches: 'بازگشت به مسابقات',
    },
    builder: {
      title: 'سازنده تیم رویایی',
      stepOf: 'مرحله {step} از ۲',
      stepTeamName: '📝 نام تیم',
      stepFormation: '🧩 ترکیب تیم',
      stepCardGroups: '📁 گروه کارت‌های این بازی',
      cardGroupsHint: 'در مرحله بعد فقط کارت‌های همین گروه‌ها قابل انتخاب هستند.',
      nextStep: 'مرحله بعد: چیدن بازیکنان ←',
      registeredLineup: '📋 ترکیب ثبت‌شده',
      toastEnterName: 'نام تیم را وارد کنید',
      toastPickAllSlots: 'برای هر {totalSlots} اسلات یک بازیکن انتخاب کنید',
      toastLineupUpdated: 'ترکیب تیم بروزرسانی شد',
      toastTeamCreated: 'تیم با موفقیت ایجاد شد',
      toastSaveError: 'خطا در ذخیره تیم',
      toastSubmittedForPoll: 'تیم برای نظرسنجی ارسال شد',
      toastSubmitError: 'خطا در ارسال تیم',
      toastLinkCopied: 'لینک تیم کپی شد',
      toastCopyFailed: 'کپی لینک ممکن نشد',
      shareVoteText: 'به تیم رویایی من رأی بده: {teamName}',
      charCount: '{length}/۴۰',
      pickSlotHint: 'یک اسلات روی زمین را انتخاب کنید',
      noCardsForPosition: 'کارتی برای این موقعیت در گروه‌های این بازی نیست',
      shareAndPoll: 'اشتراک‌گذاری و نظرسنجی تیم',
      copyTeamLink: 'کپی لینک تیم',
      seeOtherTeams: 'دیدن تیم‌های دیگر',
      submitForPoll: 'ارسال برای نظرسنجی',
      saveTeam: 'ذخیره تیم ({selected}/{total})',
      saveHint: 'برای فعال شدن دکمهٔ ذخیره، همهٔ {totalSlots} بازیکن را انتخاب کنید',
    },
    vote: {
      notFound: 'تیم یافت نشد یا لینک نامعتبر است',
      back: 'بازگشت',
    },
  },
} as const

export default fa

type DeepStringify<T> = {
  [K in keyof T]: T[K] extends string ? string : DeepStringify<T[K]>
}

export type Messages = DeepStringify<typeof fa>
